// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: company_event.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";

export const protobufPackage = "com.tick2trade.api.companyevent";

export enum PurposeType {
  TYPE_UNKNOWN = 0,
  DIVIDEND = 1,
  BOARD_MEETING = 2,
  BONUS = 3,
  FUND_RAISING = 4,
  BUYBACK = 5,
  FINANCIAL_RESULTS = 6,
  SPLIT = 7,
  VOLUNTARY_DELISTING = 8,
  OTHER_BUSINESS_MATTERS = 9,
  UNRECOGNIZED = -1,
}

export function purposeTypeFromJSON(object: any): PurposeType {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return PurposeType.TYPE_UNKNOWN;
    case 1:
    case "DIVIDEND":
      return PurposeType.DIVIDEND;
    case 2:
    case "BOARD_MEETING":
      return PurposeType.BOARD_MEETING;
    case 3:
    case "BONUS":
      return PurposeType.BONUS;
    case 4:
    case "FUND_RAISING":
      return PurposeType.FUND_RAISING;
    case 5:
    case "BUYBACK":
      return PurposeType.BUYBACK;
    case 6:
    case "FINANCIAL_RESULTS":
      return PurposeType.FINANCIAL_RESULTS;
    case 7:
    case "SPLIT":
      return PurposeType.SPLIT;
    case 8:
    case "VOLUNTARY_DELISTING":
      return PurposeType.VOLUNTARY_DELISTING;
    case 9:
    case "OTHER_BUSINESS_MATTERS":
      return PurposeType.OTHER_BUSINESS_MATTERS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PurposeType.UNRECOGNIZED;
  }
}

export function purposeTypeToJSON(object: PurposeType): string {
  switch (object) {
    case PurposeType.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case PurposeType.DIVIDEND:
      return "DIVIDEND";
    case PurposeType.BOARD_MEETING:
      return "BOARD_MEETING";
    case PurposeType.BONUS:
      return "BONUS";
    case PurposeType.FUND_RAISING:
      return "FUND_RAISING";
    case PurposeType.BUYBACK:
      return "BUYBACK";
    case PurposeType.FINANCIAL_RESULTS:
      return "FINANCIAL_RESULTS";
    case PurposeType.SPLIT:
      return "SPLIT";
    case PurposeType.VOLUNTARY_DELISTING:
      return "VOLUNTARY_DELISTING";
    case PurposeType.OTHER_BUSINESS_MATTERS:
      return "OTHER_BUSINESS_MATTERS";
    case PurposeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CompanyEventProto {
  primaryCode: string;
  purpose: PurposeType[];
  details: string;
  date: string;
  companyCode: string;
  primaryExchange: Exchange;
  displayPurpose: string;
}

export interface GetCompanyEventsResponse {
  companyEvents: CompanyEventProto[];
}

function createBaseCompanyEventProto(): CompanyEventProto {
  return {
    primaryCode: "",
    purpose: [],
    details: "",
    date: "",
    companyCode: "",
    primaryExchange: 0,
    displayPurpose: "",
  };
}

export const CompanyEventProto = {
  encode(message: CompanyEventProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.primaryCode !== "") {
      writer.uint32(10).string(message.primaryCode);
    }
    writer.uint32(18).fork();
    for (const v of message.purpose) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.details !== "") {
      writer.uint32(26).string(message.details);
    }
    if (message.date !== "") {
      writer.uint32(34).string(message.date);
    }
    if (message.companyCode !== "") {
      writer.uint32(42).string(message.companyCode);
    }
    if (message.primaryExchange !== 0) {
      writer.uint32(48).int32(message.primaryExchange);
    }
    if (message.displayPurpose !== "") {
      writer.uint32(58).string(message.displayPurpose);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompanyEventProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyEventProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.primaryCode = reader.string();
          continue;
        case 2:
          if (tag === 16) {
            message.purpose.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.purpose.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.details = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.date = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.primaryExchange = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.displayPurpose = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyEventProto {
    return {
      primaryCode: isSet(object.primaryCode) ? globalThis.String(object.primaryCode) : "",
      purpose: globalThis.Array.isArray(object?.purpose) ? object.purpose.map((e: any) => purposeTypeFromJSON(e)) : [],
      details: isSet(object.details) ? globalThis.String(object.details) : "",
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      companyCode: isSet(object.companyCode) ? globalThis.String(object.companyCode) : "",
      primaryExchange: isSet(object.primaryExchange) ? exchangeFromJSON(object.primaryExchange) : 0,
      displayPurpose: isSet(object.displayPurpose) ? globalThis.String(object.displayPurpose) : "",
    };
  },

  toJSON(message: CompanyEventProto): unknown {
    const obj: any = {};
    if (message.primaryCode !== "") {
      obj.primaryCode = message.primaryCode;
    }
    if (message.purpose?.length) {
      obj.purpose = message.purpose.map((e) => purposeTypeToJSON(e));
    }
    if (message.details !== "") {
      obj.details = message.details;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.companyCode !== "") {
      obj.companyCode = message.companyCode;
    }
    if (message.primaryExchange !== 0) {
      obj.primaryExchange = exchangeToJSON(message.primaryExchange);
    }
    if (message.displayPurpose !== "") {
      obj.displayPurpose = message.displayPurpose;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompanyEventProto>, I>>(base?: I): CompanyEventProto {
    return CompanyEventProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompanyEventProto>, I>>(object: I): CompanyEventProto {
    const message = createBaseCompanyEventProto();
    message.primaryCode = object.primaryCode ?? "";
    message.purpose = object.purpose?.map((e) => e) || [];
    message.details = object.details ?? "";
    message.date = object.date ?? "";
    message.companyCode = object.companyCode ?? "";
    message.primaryExchange = object.primaryExchange ?? 0;
    message.displayPurpose = object.displayPurpose ?? "";
    return message;
  },
};

function createBaseGetCompanyEventsResponse(): GetCompanyEventsResponse {
  return { companyEvents: [] };
}

export const GetCompanyEventsResponse = {
  encode(message: GetCompanyEventsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.companyEvents) {
      CompanyEventProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCompanyEventsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.companyEvents.push(CompanyEventProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyEventsResponse {
    return {
      companyEvents: globalThis.Array.isArray(object?.companyEvents)
        ? object.companyEvents.map((e: any) => CompanyEventProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCompanyEventsResponse): unknown {
    const obj: any = {};
    if (message.companyEvents?.length) {
      obj.companyEvents = message.companyEvents.map((e) => CompanyEventProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCompanyEventsResponse>, I>>(base?: I): GetCompanyEventsResponse {
    return GetCompanyEventsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCompanyEventsResponse>, I>>(object: I): GetCompanyEventsResponse {
    const message = createBaseGetCompanyEventsResponse();
    message.companyEvents = object.companyEvents?.map((e) => CompanyEventProto.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
